import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';


const CancelButton = ({ onClick }) => (
  <Button
    key='cancel'
    kind='primary'
    className='mr-3'
    onClick={onClick}
  >
    Cancel
  </Button>
);

CancelButton.propTypes = {
  onClick: PropTypes.func
};

export default CancelButton;


// WEBPACK FOOTER //
// src/components/shared/CancelButton/index.jsx